import {IEnvironment} from "./IEnvironment";

export const environment: IEnvironment = {
  production: false,
  env_name: 'stage',
  api: {
    url: 'https://api.ercm.teraone-preview.de/api/dashboard/v1',
    session_domain: '.ercm.teraone-preview.de',
  },
}
